export default "__VITE_ASSET__Ddt18Sm___"